
const main = resolve => require(['@/views/index/index.vue'], resolve)// 主页
const paymentRecord = resolve => require(['@/views/paymentRecord/paymentRecord.vue'], resolve)// 打款记录

export default [{
  path: '/index',
  component: main,
  children: [
    // 打款记录
    {
      name: 'PaymentRecord',
      path: '/aq/paymentRecord',
      alias: ['/aq/paymentRecord.htm'],
      component: paymentRecord
    }
  ]
}
]
